import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { twMerge } from 'tailwind-merge';

import Typography from 'components-new/typography/typography';

const TooltipProvider = TooltipPrimitive.Provider;

const ToolTipRoot = TooltipPrimitive.Root;

const ToolTipArrow = TooltipPrimitive.Arrow;

const TooltipTrigger = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Trigger>
>(({ ...tooltipTriggerProps }, ref) => (
  <TooltipPrimitive.Trigger ref={ref} {...tooltipTriggerProps} />
));
TooltipTrigger.displayName = TooltipPrimitive.Trigger.displayName;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
  // eslint-disable-next-line react/prop-types
>(({ sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content ref={ref} sideOffset={sideOffset} {...props} />
));

TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { ToolTipRoot, TooltipTrigger, TooltipContent, TooltipProvider };

interface ToolTipProps {
  children: React.ReactNode;
  text: string;
  className?: string;
  tooltipRootProps?: TooltipPrimitive.TooltipProps;
  tooltipTriggerProps?: TooltipPrimitive.TooltipTriggerProps;
  toolTipContentProps?: TooltipPrimitive.TooltipContentProps;
  tooltipArrowProps?: TooltipPrimitive.TooltipArrowProps;
}

const Tooltip: React.FC<ToolTipProps> = ({
  children,
  text,
  className,
  tooltipRootProps,
  tooltipTriggerProps,
  toolTipContentProps,
  tooltipArrowProps,
}) => {
  const contentClassName = twMerge(
    'z-50 mx-0.5 overflow-hidden rounded-md border-lg shadow-md',
    'bg-gray-800 text-white opacity-80 px-2 py-1 flex items-center text-center',
    'max-w-[240px]',
    className,
  );

  return (
    <TooltipProvider>
      <ToolTipRoot {...tooltipRootProps}>
        <TooltipTrigger asChild {...tooltipTriggerProps}>
          {children}
        </TooltipTrigger>
        <TooltipContent className={contentClassName} {...toolTipContentProps}>
          <Typography variant="body-medium" as="span">
            {text}
          </Typography>
          <ToolTipArrow
            {...tooltipArrowProps}
            className="fill-gray-800 opacity-80 stroke-2"
          />
        </TooltipContent>
      </ToolTipRoot>
    </TooltipProvider>
  );
};

export default Tooltip;
